import { Member } from "../../types/workgroup";

export const demoUserId = "demo.user";

export const demoMembers: Member[] = [
  {
    userId: "demo.user",
    userName: "Demo User",
    email: "demo.user@wrapsodyeco.com",
    deptCode: "DEPT_001",
    deptName: "Product Team",
    positionCode: "P001",
    positionName: "Manager",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "alice.johnson",
    userName: "Alice Johnson",
    email: "alice.johnson@wrapsodyeco.com",
    deptCode: "DEPT_002",
    deptName: "Engineering",
    positionCode: "P002",
    positionName: "Senior Engineer",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "bob.chen",
    userName: "Bob Chen",
    email: "bob.chen@wrapsodyeco.com",
    deptCode: "DEPT_002",
    deptName: "Engineering",
    positionCode: "P003",
    positionName: "Engineer",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "carol.smith",
    userName: "Carol Smith",
    email: "carol.smith@wrapsodyeco.com",
    deptCode: "DEPT_003",
    deptName: "Marketing",
    positionCode: "P001",
    positionName: "Manager",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "david.kim",
    userName: "David Kim",
    email: "david.kim@wrapsodyeco.com",
    deptCode: "DEPT_004",
    deptName: "Security",
    positionCode: "P002",
    positionName: "Senior Engineer",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "emma.wilson",
    userName: "Emma Wilson",
    email: "emma.wilson@wrapsodyeco.com",
    deptCode: "DEPT_001",
    deptName: "Product Team",
    positionCode: "P003",
    positionName: "Engineer",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "frank.patel",
    userName: "Frank Patel",
    email: "frank.patel@wrapsodyeco.com",
    deptCode: "DEPT_005",
    deptName: "Customer Success",
    positionCode: "P001",
    positionName: "Manager",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "grace.lee",
    userName: "Grace Lee",
    email: "grace.lee@wrapsodyeco.com",
    deptCode: "DEPT_006",
    deptName: "Finance",
    positionCode: "P002",
    positionName: "Senior Analyst",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "henry.martin",
    userName: "Henry Martin",
    email: "henry.martin@wrapsodyeco.com",
    deptCode: "DEPT_007",
    deptName: "HR & People",
    positionCode: "P001",
    positionName: "Manager",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "iris.taylor",
    userName: "Iris Taylor",
    email: "iris.taylor@wrapsodyeco.com",
    deptCode: "DEPT_008",
    deptName: "Legal",
    positionCode: "P002",
    positionName: "Senior Counsel",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "james.brown",
    userName: "James Brown",
    email: "james.brown@wrapsodyeco.com",
    deptCode: "DEPT_002",
    deptName: "Engineering",
    positionCode: "P004",
    positionName: "Junior Engineer",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "kate.davis",
    userName: "Kate Davis",
    email: "kate.davis@wrapsodyeco.com",
    deptCode: "DEPT_003",
    deptName: "Marketing",
    positionCode: "P003",
    positionName: "Specialist",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "liam.garcia",
    userName: "Liam Garcia",
    email: "liam.garcia@wrapsodyeco.com",
    deptCode: "DEPT_009",
    deptName: "Data Analytics",
    positionCode: "P002",
    positionName: "Senior Analyst",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "mia.rodriguez",
    userName: "Mia Rodriguez",
    email: "mia.rodriguez@wrapsodyeco.com",
    deptCode: "DEPT_005",
    deptName: "Customer Success",
    positionCode: "P003",
    positionName: "Specialist",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  {
    userId: "noah.thompson",
    userName: "Noah Thompson",
    email: "noah.thompson@wrapsodyeco.com",
    deptCode: "DEPT_009",
    deptName: "Data Analytics",
    positionCode: "P003",
    positionName: "Analyst",
    roleCode: "R001",
    roleName: "General User",
    userType: 1,
    status: 1,
    linkedYN: "Y",
  },
  // external users
  {
    userId: "partner.ext@globalcorp.com",
    userName: "Partner External",
    email: "partner.ext@globalcorp.com",
    deptCode: null,
    deptName: "Global Corp",
    positionCode: null,
    positionName: null,
    roleCode: null,
    roleName: null,
    userType: 2,
    status: 1,
    linkedYN: "N",
  },
  {
    userId: "vendor.kim@techpartner.io",
    userName: "Vendor Kim",
    email: "vendor.kim@techpartner.io",
    deptCode: null,
    deptName: "Tech Partner",
    positionCode: null,
    positionName: null,
    roleCode: null,
    roleName: null,
    userType: 2,
    status: 1,
    linkedYN: "N",
  },
  {
    userId: "client.lee@enterprise.co",
    userName: "Client Lee",
    email: "client.lee@enterprise.co",
    deptCode: null,
    deptName: "Enterprise Co",
    positionCode: null,
    positionName: null,
    roleCode: null,
    roleName: null,
    userType: 2,
    status: 1,
    linkedYN: "N",
  },
];
